import { render, staticRenderFns } from "./SaitenResultDownload.vue?vue&type=template&id=c0ef823c&"
import script from "./SaitenResultDownload.vue?vue&type=script&lang=ts&"
export * from "./SaitenResultDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports